import React from 'react';
import {UnorderedListProps} from 'react-markdown/lib/ast-to-react';

export const UnorderedList = (props: React.PropsWithChildren<UnorderedListProps>) => (
  <ul {...props} />
);
